import { CommandType, CommandTypeData } from ".";
import { CommandData, CommandHelper, CommandProviders } from "../commands/command";

import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { Command } from "./command";

export interface SceneSteps {
    [key: number]: SceneStep;
}

export interface SceneStep {
    action: CommandType;
    delay: number;
    enabled?: boolean;
    commandHelper?: CommandHelper;
}

export interface SceneCommand extends Command {
    createdByMch: boolean;
    steps: SceneSteps;
    commandCount: number;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface SceneCommandData extends CommandData {
    created_by_mch: boolean;
    command_count: number;
    steps: { [key: number]: SceneStepsData };
}

export interface SceneStepsData {
    action: CommandTypeData;
    delay: number;
    enabled?: boolean;
    commandHelper?: CommandHelper;
}
/* eslint-enable @typescript-eslint/naming-convention */

export const isSceneCommand = (command: Command): command is SceneCommand =>
    command && command.commandType === CommandProviders.SCENE && "steps" in command;

export class SceneCommandHelper extends CommandHelper {
    static readonly importMap: ImportMap<SceneCommand, SceneCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "created_by_mch", o: "createdByMch" },
        { i: "steps", o: "steps" },
        { i: "command_count", o: "commandCount" },
    ];

    static fromCHObject(scene: SceneCommandData, steps?: SceneSteps): SceneCommand {
        return {
            name: scene[this.importMap[0].i] as string,
            commandId: scene[this.importMap[1].i] as string,
            commandType: scene[this.importMap[2].i] as string,
            createdByMch: scene[this.importMap[3].i] === true,
            steps,
            commandCount: scene[this.importMap[5].i] as number,
        };
    }

    static hasOnlyNotificationCommands(scene: SceneCommand): boolean {
        const steps = scene.steps || {};
        const realSteps = Object.values(steps).filter(step => step.action?.command_type !== CommandProviders.WAIT_TIME);
        return (
            realSteps.length &&
            !realSteps.some(
                step => step.action?.command_type !== CommandProviders.PUSH && step.action?.command_type !== CommandProviders.EMAIL
            )
        );
    }

    static getDefault() {
        return {
            name: "name",
            commandId: null,
            commandType: CommandProviders.SCENE,
            createdByMch: true,
            steps: {},
            commandCount: 0,
        };
    }
}
